import type { EmpPersonRef } from "./feed";

/**
 * Reporting and moderation, shared by client and server. Reports go to the
 * people who can moderate the post: Admins, and Managers for posts aimed at
 * their locations or Everyone posts by their people (roadmap rule). Who
 * reported is shown only to them.
 */

export const EMP_REPORT_REASONS = [
  "harassment",
  "inappropriate",
  "spam",
  "misinformation",
  "privacy",
  "other",
] as const;
export type EmpReportReason = (typeof EMP_REPORT_REASONS)[number];

export const REPORT_DETAILS_MAX = 1000;
export const REPORTS_PAGE_SIZE = 20;
/** Open reports are counted up to this; a badge at it reads "99+". */
export const REPORT_COUNT_CAP = 99;

export type EmpReportTarget = "post" | "comment";

/** keep: dismiss the reports; hide: posts only, until restored; remove: gone for everyone. */
export const EMP_MODERATION_ACTIONS = ["keep", "hide", "restore", "remove"] as const;
export type EmpModerationAction = (typeof EMP_MODERATION_ACTIONS)[number];

/** One reported post or comment in the queue, with its open reports grouped. */
export interface EmpReportedItem {
  targetType: EmpReportTarget;
  targetId: string;
  postId: string;
  author: EmpPersonRef;
  /** The post's title, or the first part of its text or the comment's. */
  snippet: string;
  hidden: boolean;
  reportCount: number;
  reasons: EmpReportReason[];
  /** Newest first; shown only to moderators. */
  reports: {
    reporter: EmpPersonRef;
    reason: EmpReportReason;
    details: string | null;
    createdAt: string;
  }[];
  lastReportedAt: string;
}

export interface EmpReportQueuePage {
  items: EmpReportedItem[];
  nextCursor: string | null;
}
